import { useEventListener } from '@vueuse/core'

export default function (el) {
  let dragging = false
  let startX = 0
  let startY = 0
  let scrollLeft = 0
  let scrollTop = 0

  const onMouseDown = e => {
    dragging = true
    startX = e.pageX
    startY = e.pageY
    scrollLeft = el.scrollLeft
    scrollTop = el.scrollTop
    el.style.cursor = 'grabbing'
    e.preventDefault()
  }

  const onMouseMove = e => {
    if (!dragging) return
    const dx = e.pageX - startX
    const dy = e.pageY - startY
    el.scrollLeft = scrollLeft - dx
    el.scrollTop = scrollTop - dy
  }

  const onMouseUpOrLeave = () => {
    dragging = false
    el.style.cursor = 'grab'
  }

  useEventListener(el, 'mousedown', onMouseDown)
  useEventListener(window, 'mousemove', onMouseMove)
  useEventListener(window, 'mouseup', onMouseUpOrLeave)
  useEventListener(el, 'mouseleave', onMouseUpOrLeave)
}
